// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { MicrophoneIcon } from '@moia-dev/pace-icons'
import { DisengagementVoicebotAreaRoutes } from './DisengagementVoicebotAreaRoutes'

export const DisengagementVoicebotAreaNavigationIcon = MicrophoneIcon

export const DisengagementVoicebotAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={DisengagementVoicebotAreaRoutes.route}
      Icon={MicrophoneIcon}
    />
  )
}
